import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import Status from 'design-system/Status';
import useColors from 'hooks/useColors';
import { selectAutosaveStatusObj } from 'reducers/selectors';
const getInactiveText = (isPending, isPaused, actionRequired) => {
    if (actionRequired) {
        return 'Action required';
    }
    if (isPaused) {
        return 'Paused';
    }
    if (isPending) {
        return 'Pending';
    }
    return '';
};
const AutosaveStatus = () => {
    const colors = useColors();
    const autosaveStatusObj = useAppSelector(selectAutosaveStatusObj);
    const inActiveColor = useMemo(() => {
        if (autosaveStatusObj?.actionRequired) {
            return undefined;
        }
        if (autosaveStatusObj?.isPaused) {
            return colors.status.offline;
        }
        if (autosaveStatusObj?.isPending) {
            return colors.status.informational;
        }
        return undefined;
    }, [
        autosaveStatusObj?.actionRequired,
        autosaveStatusObj?.isPaused,
        autosaveStatusObj?.isPending,
        colors.status.offline,
        colors.status.informational,
    ]);
    if (!autosaveStatusObj) {
        return <View testID="emptyView"/>;
    }
    return (<Status activeText="Working" inActiveColor={inActiveColor} active={!autosaveStatusObj.actionRequired && !autosaveStatusObj.isPending && !autosaveStatusObj.isPaused} inactiveText={getInactiveText(autosaveStatusObj.isPending, autosaveStatusObj.isPaused, !!autosaveStatusObj.actionRequired)}/>);
};
export default memo(AutosaveStatus);
